<template>
  <b-modal
    id="modal-danger"
    v-model="modalShow"
    ok-variant="danger"
    ok-title="Accept"
    modal-class="modal-normal"
    centered>
    <div class="d-block text-center">
      <p class="font-weight-medium text-28">
        Confirm to Delete
      </p>
    </div>
    <div
      class="mx-auto"
      style="width: 80%;">
      <b-row
        v-for="item, index in itemsKey"
        :key="`delete-item-${index}`">
        <b-col
          cols="3"
          class="d-flex justify-content-end">
          <span>{{ item }}</span>
        </b-col>
        <b-col cols="9">
          <span>{{ itemsValue[index] }}</span>
        </b-col>
      </b-row>
    </div>
    <template #modal-footer="{ hide }">
      <div class="mx-auto">
        <b-button
          variant="outline-danger"
          style="margin-right: 12px"
          @click="confirmDelete()">
          Confirm
        </b-button>
        <b-button
          variant="primary"
          @click="hide">
          Cancel
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    isDeleteModalActive: {
      type: Boolean,
      required: true
    },
    items: {
      type: Object,
      required: true
    }
  },
  computed: {
    modalShow: {
      get () {
        return this.isDeleteModalActive
      },
      set (val) {
        this.$emit('update:is-delete-modal-active', val)
      }
    },
    itemsKey () {
      return Object.keys(this.items)
    },
    itemsValue () {
      return Object.values(this.items)
    }
  },
  methods: {
    confirmDelete () {
      this.$emit('update:is-delete-modal-active', false)
      this.$emit('confirm-delete', this.items)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
